import {Injectable} from '@angular/core';
import {NativeDateAdapter} from '@angular/material/core';

/**
 * NativeDateAdapter hard-codes getFirstDayOfWeek() to 0 (Sunday), because a native JS Date
 * cannot report the locale's first day. That makes each calendar row a Sunday-to-Saturday week.
 *
 * The sales comparison selects ISO-8601 weeks (Monday to Sunday), so with the default adapter a
 * selected week would straddle two calendar rows and the week highlight would read as broken.
 * Starting the week on Monday makes one calendar row exactly one ISO week.
 */
@Injectable()
export class IsoWeekDateAdapter extends NativeDateAdapter {
  override getFirstDayOfWeek(): number {
    return 1;
  }
}
